import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {
  BillingType,
  StripePromotionCode,
  StripePromotionCodeSuccess,
} from '@pedix-workspace/utils';
import { StripeCouponCodeService } from './stripe-coupon-code.service';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';
import { IconCloseComponent } from '@pedix-workspace/angular-ui-icons';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';

import { TextFieldComponent } from '@pedix-workspace/angular-ui-form';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'pxw-stripe-coupon-code',
    templateUrl: './stripe-coupon-code.component.html',
    styleUrls: ['./stripe-coupon-code.component.scss'],
    imports: [FormsModule, TextFieldComponent, ButtonComponent, IconCloseComponent, AlertComponent]
})
export class StripeCouponCodeComponent implements OnInit {
  validatingCoupon = false;
  promotionCodeInput: string;
  promotionCodeInfo: StripePromotionCode;

  @Input() apiUrl: string;
  @Input() billingType: BillingType;
  @Input() promotionCode: string;
  @Output() handleCouponSuccess = new EventEmitter<StripePromotionCodeSuccess | null>();
  @Output() handleCouponError = new EventEmitter<string>();

  private stripeCouponCodeService = inject(StripeCouponCodeService);

  constructor() {}

  ngOnInit(): void {
    if (this.promotionCode) {
      this.promotionCodeInput = this.promotionCode;
      this.validateCoupon();
    }
  }

  async validateCoupon() {
    if (!this.promotionCodeInput) {
      return;
    }

    this.validatingCoupon = true;
    this.stripeCouponCodeService
      .validateCoupon(this.apiUrl, this.promotionCodeInput, this.billingType)
      .subscribe(
        (response: any) => {
          this.promotionCodeInfo = response.result as StripePromotionCode;
          this.handleCouponSuccess.emit({
            couponId: this.promotionCodeInfo.couponId,
            promotionCode: this.promotionCodeInput,
          });
          this.validatingCoupon = false;
        },
        error => {
          const errorMessage = error.error.error;
          this.handleCouponError.emit(errorMessage);
          this.validatingCoupon = false;
        },
      );
  }
  removeCoupon() {
    this.promotionCodeInput = null;
    this.promotionCodeInfo = null;
    this.handleCouponSuccess.emit(null);
  }
}
